<template>
  <router-link
    :to="{
      name: 'admin-project-details',
      params: { id: project._id },
    }"
  >
    <v-card class="mx-auto">
      <v-img
        class="white--text align-end"
        height="200px"
        :src="project.file.split(',')[0]"
        lazy-src="https://picsum.photos/id/11/100/60"
      >
        <v-card-title class="tw-bg-black tw-opacity-50">{{
          project.name
        }}</v-card-title>
      </v-img>
      <v-card-text>
        <div v-if="project">
          <b>Description:</b> {{ project.description.substring(0, 30) }}
        </div>
        <div><b>Sector:</b> {{ project.sector }}</div>
        <section><b>Carbon Balance:</b> {{ project.carbon_balance }}</section>
      </v-card-text>

      <vue-element-loading
        v-if="loading"
        :active="loading"
        :is-full-screen="true"
      />
    </v-card>
  </router-link>
</template>

<script>
export default {
  props: ["project"],
  data() {
    return {
      loading: false,
      dialog: false,
      errors: {},
    };
  },
};
</script>

<style lang="scss" scoped></style>
